import { mapActions } from 'vuex';

export default {
    name: 'TicketChangeCompanyDialog',

    props: {
        value: { type: Boolean, required: true },
        item: { type: Object, required: true },
    },

    data() {
        return {
            selectedCompanyId: null,
            changeCompanyLoading: false,
        };
    },

    computed: {
        isOpen: {
            get() { return this.value; },
            set(val) { this.$emit('input', val); },
        },

        companies() {
            return this.$store.getters['auth/getCompanies'] || [];
        },
    },

    methods: {
        ...mapActions('ticket', ['changeCompany']),

        handleClose() {
            this.isOpen = false;
            this.selectedCompanyId = null;
        },

        async handleSubmit() {
            if (!this.selectedCompanyId) {
                this.$swal({
                    icon: 'warning',
                    title: 'Compañía requerida',
                    text: 'Debes seleccionar una compañía.',
                    confirmButtonColor: '#0039a6',
                });
                return;
            }

            const { id: ticketId } = this.item;

            this.changeCompanyLoading = true;

            try {
                const { ok, error } = await this.changeCompany({
                    ticketId,
                    companyId: this.selectedCompanyId,
                });

                if (ok) {
                    this.$swal({
                        icon: 'success',
                        title: 'Cambio de compañía exitoso',
                        confirmButtonColor: '#0039a6',
                    });

                    this.isOpen = false;
                    this.selectedCompanyId = null;
                    this.$emit('refresh');
                } else {
                    this.$swal({
                        icon: 'error',
                        title: 'Error',
                        text: error?.data?.message || 'No se pudo cambiar la compañía del ticket.',
                        confirmButtonColor: '#0039a6',
                    });
                }
            } catch (err) {
                this.$swal({
                    icon: 'error',
                    title: 'Error inesperado',
                    text: err?.message || 'Algo salió mal al cambiar la compañía del ticket.',
                    confirmButtonColor: '#0039a6',
                });
            } finally {
                this.changeCompanyLoading = false;
            }
        },
    },
};
